import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=3fa3e510&scoped=true&"
import script from "./UpdatePassword.vue?vue&type=script&lang=ts&"
export * from "./UpdatePassword.vue?vue&type=script&lang=ts&"
import style0 from "./UpdatePassword.vue?vue&type=style&index=0&id=3fa3e510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa3e510",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VForm,VRow,VTextField})
